<template>
  <div class="geometry">
    <MainBackButton :forceHome="true" />
    <p v-if="geometryType" class="header">{{ geometryType }}</p>

    <div class="map-wrapper">
      <div :id="uniqueMapID" class="map" />
    </div>

    <div v-if="geometryType">
      <span class="button toggle-btn is-small" @click="toggleZoom">
        <i class="fa fa-expand has-text-link" />
      </span>
    </div>

    <span
      v-if="polygon && workflowID"
      class="button is-primary is-rounded save"
      @click="savePolygon"
    >
      <i class="fa fa-save" /> &nbsp;Save
    </span>

    <!-- <div
      v-if="showSavePolygon"
      class="save-wrapper"
      @click="showSavePolygon = false"
    >
      <button class="delete is-large is-pulled-right" />
      <span class="button is-rounded is-link is-pulled-right">Save</span>

      <h1 class="subtitle">Save polygon</h1>

      <input class="input is-dark" placeholder="Search business workflow" />
    </div> -->
  </div>
</template>

<script>
import MainBackButton from "@/components/MainBackButton.vue";

import L from "leaflet";
import "leaflet.locatecontrol";
// import "leaflet-edgebuffer";
import "leaflet.awesome-markers";
import "leaflet-draw";

L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";

export default {
  name: "Geometry",
  components: {
    MainBackButton,
  },
  data() {
    return {
      uniqueMapID: "geometry-map",
      map: undefined,
      locateControl: undefined,
      polygon: null, // pastable, `key: value,`
      showSavePolygon: false,
      geometryType: null,
      workflowID: null,
      userMarker: null,
      businessMarker: null,
      toggle: false,
      geojson: null, // just the `value`, not `key: value,`
    };
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
  },
  mounted() {
    this.initMap();

    var query = this.$route.query;
    if (query) {
      this.geometryType = query.type;
      this.workflowID = query.workflow_id;
      if (this.workflowID) this.centerOnBusiness();
    }
  },
  methods: {
    savePolygon() {
      // this.showSavePolygon = true // old way
      var data = {
        workflow_id: this.workflowID,
        key: this.geometryType, // pickup_area_polygon, ...
        value: this.geojson,
      };
      var loader = this.loadingDots("cyan");
      this.$store
        .dispatch("saveGeometryOnWorkflow", data)
        .then(() => {
          this.successToast("Saved!");
          // response should be array of nearby geometries of same type for same workflow name
          // that shouldn't overlap, that way if they do we can see it and fix it
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleZoom() {
      if (this.toggle) this.map.panTo(this.userMarker.getLatLng());
      else this.map.panTo(this.businessMarker.getLatLng());
      this.toggle = !this.toggle;
    },
    centerOnBusiness() {
      this.map.setView(this.business, 16);

      var iconOpts = { icon: "store-alt", markerColor: "pink" };
      var icon = L.AwesomeMarkers.icon(iconOpts);
      var marker = L.marker(this.business, { icon: icon }).addTo(this.map);
      var opts = { closeButton: false, autoPan: true };
      marker.bindPopup(this.business.name, opts).openPopup();
      this.businessMarker = marker;
    },
    drawUserLocation() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.map);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var initialLocation = this.$store.getters.getUserLocation;

      var mapOpts = { attributionControl: false };
      this.map = L.map(this.uniqueMapID, mapOpts);
      this.map.setView(initialLocation, 13);
      this.map.removeControl(this.map.zoomControl);
      L.control.zoom({ position: "topright" }).addTo(this.map);
      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 3,
        maxZoom: 19,
      }).addTo(this.map);

      this.drawUserLocation();
      this.setupDraw();
    },
    setupDraw() {
      var drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      // remove annoying tooltips
      L.drawLocal.draw.handlers.polygon.tooltip.start = null;
      L.drawLocal.draw.handlers.polygon.tooltip.draw = null;
      L.drawLocal.draw.handlers.polygon.tooltip.finish = null;
      L.drawLocal.draw.handlers.polygon.tooltip.undo = null;
      L.drawLocal.draw.handlers.polygon.tooltip.text = null;
      L.drawLocal.draw.handlers.polygon.tooltip.edit = null;
      L.drawLocal.draw.handlers.polygon.tooltip.cont = null;
      L.drawLocal.draw.handlers.polygon.tooltip.end = null;

      var drawOpts = {
        position: "bottomright",
        draw: {
          polyline: false,
          circle: false,
          circlemarker: false,
          marker: false,
          rectangle: false,
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            drawError: { color: "#FF3860", message: "Invalid" },
            shapeOptions: { color: "#3273DC" }, //#bada55
          },
        },
        edit: { featureGroup: drawnItems, remove: true },
      };
      var drawControl = new L.Control.Draw(drawOpts);
      this.map.addControl(drawControl);

      this.map.on(L.Draw.Event.CREATED, (e) => {
        drawnItems.clearLayers(); // remove any existing layers, only 1 allowed
        var polygon = e.layer;
        console.log(JSON.stringify(polygon.toGeoJSON()));
        drawnItems.addLayer(polygon);
        this.geojson = polygon.toGeoJSON().geometry.coordinates;
        var coords = JSON.stringify(polygon.toGeoJSON().geometry.coordinates);
        var pastable = `"free_delivery_polygon": ${coords},`;
        this.$copyText(pastable);
        this.infoToast("Copied polygon!", "top");
        // setTimeout(() => { polygon.on("click", () => this.infoToast("Copied polygon!", "top")); }, 1000);
        this.polygon = pastable;
        // this.geojson = coords;
      });

      this.map.on("draw:edited", () => {
        console.log("edited", drawnItems); // there's only a single item...
        drawnItems.eachLayer((l) => {
          //   console.log(JSON.stringify(l.toGeoJSON()));
          this.geojson = l.toGeoJSON().geometry.coordinates;
          var coords = JSON.stringify(l.toGeoJSON().geometry.coordinates);
          var pastable = `"free_delivery_polygon": ${coords},`;
          this.$copyText(pastable);
          this.infoToast("Copied polygon!", "top");
          this.polygon = pastable;
          // this.geojson = coords;
        });
      });

      this.map.on("draw:deleted", () => (this.polygon = null));
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  position: relative;
  height: 100vh;
  width: 100vw;
  z-index: 0;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
}
.save {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 10px;
}
.save-wrapper {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(17, 34, 51, 0.95);
}
.subtitle {
  text-align: left;
  margin-top: 16px;
  margin-left: 55px;
  color: white;
  opacity: 0.6;
}
.header {
  position: absolute;
  text-align: left;
  margin-top: 12px;
  margin-left: 58px;
  color: lightseagreen;
  border-radius: 8px;
  font-size: 1.1em;
  z-index: 2;
  padding: 4px;
  background-color: white;
  box-shadow: 1px 1px 2px grey;
}
.button {
  margin: 10px;
}
.delete {
  margin: 10px;
}
input {
  width: calc(100vw - 20px);
}
.toggle-btn {
  position: absolute;
  top: 76px;
  /* top: 66px; */
  right: 1px;
  padding: 8px;
  font-size: 0.9em;
  /* border-radius: 4px;
  height: 26px;
  width: 26px; */
  box-shadow: 0 0 0 1px rgba(128, 128, 128, 0.4);
}
</style>


<style lang="scss">
#geometry-map {
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    // max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    color: grey;
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .pulse {
    animation: shadow-pulse 2s infinite;
  }
  @keyframes shadow-pulse {
    0% {
      box-shadow: 0 0 0 0px #2693da;
    }
    100% {
      box-shadow: 0 0 0 4px #2692da55;
    }
  }
}
</style>